<template>
    <div id="map" class="map"></div>
</template>

<script>
import convertor from './chncrs/chncrs.js';

console.log(convertor);

export default {
    components: {},
    data() {
        return {
            map: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let self = this;
            const map = new maptalks.Map('map', {
                center: [112.900626, 23.356027],
                zoom: 17,
                pitch: 60,
            });
            this.map = map;
            new maptalks.TileLayer('base', {
                urlTemplate:
                    'http://wprd{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=6&z={z}&x={x}&y={y}',
                subdomains: ['01', '02', '03', '04'],
                spatialReference: {
                    projection: 'EPSG:3857',
                },
                offset(z) {
                    // 临时变量用于接受中间结果，避免创建新对象
                    return self.setOffset(z);
                },
            }).addTo(map);
            const layer = new maptalks.Geo3DTilesLayer('3dtiles', {
                services: [
                    {
                        url: '/map/3d/20230616lubaozumiao_Cesium_4547/tileset.json',
                    },
                ],
            });
            const groupLayer = new maptalks.GroupGLLayer('group', [layer]);
            groupLayer.addTo(map);
        },
        setOffset(z) {
            const targetCoord = new maptalks.Coordinate(0, 0);
            const POINT0 = new maptalks.Coordinate(0, 0);
            const POINT1 = new maptalks.Coordinate(0, 0);
            // 实时计算wgs84和gcj02瓦片的偏移量
            const center = this.map.getCenter();
            const c = convertor.transform(center.toArray(), 'GCJ02', 'WGS84');
            targetCoord.set(c[0], c[1]);
            const offset = this.map
                .coordToPoint(center, z, POINT0)
                ._sub(this.map.coordToPoint(targetCoord, z, POINT1));
            return offset._round().toArray();
        },
    },
};
</script>

<style lang="scss">
.map {
    width: 100%;
    height: 100vh;
}
</style>
